var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { disabled: !_vm.hasPermission || _vm.schools.length < 2 },
          on: {
            click: function($event) {
              _vm.showModal = true
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-compress" }),
          _vm._v("\n    Merge Schools\n  ")
        ]
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c("merge-schools-modal", {
            attrs: {
              "external-open": _vm.showModal,
              schools: _vm.schools,
              users: _vm.users,
              "domain-uuid": _vm.domainUuid
            },
            on: {
              "merge-success": _vm.handleSuccess,
              "update:externalOpen": function($event) {
                _vm.showModal = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }